<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column;">
      <h3>Description</h3>

      <p>
        The In-App Demo Application is designed and developed as a demo tool for the Account Managers and Customer Solutions Team to demonstrate the use of the Nexmo SDK to build a chat application that makes use of the built in Conversation APIs, along with capabilities of voice calls for in-app voice calls, PSTN calls and SIP calls via Voice APIs.
      </p>

      
    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'demo',
    components: {
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>